import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CRM from "@/pages/CRM";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Quotations from "@/pages/Quotations";
import Finance from "@/pages/Finance";
import PettyCash from "@/pages/PettyCash";
import Masters from "@/pages/Masters";
import Inventory from "@/pages/Inventory";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Attendance from "@/pages/Attendance";
import Account from "@/pages/Account";
import ImportSheet from "@/pages/ImportSheet";
import Profit from "@/pages/Profit";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">Memuat Puade OS...</div>;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/crm" element={<Protected><CRM /></Protected>} />
      <Route path="/projects" element={<Protected><Projects /></Protected>} />
      <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
      <Route path="/quotations" element={<Protected><Quotations /></Protected>} />
      <Route path="/finance" element={<Protected><Finance /></Protected>} />
      <Route path="/pettycash" element={<Protected><PettyCash /></Protected>} />
      <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
      <Route path="/masters" element={<Protected><Masters /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
      <Route path="/absen" element={<Protected><Attendance /></Protected>} />
      <Route path="/laba" element={<Protected><Profit /></Protected>} />
      <Route path="/sheets" element={<Protected><ImportSheet /></Protected>} />
      <Route path="/akun" element={<Protected><Account /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
